import React, { Component } from 'react';


export const AuthContext = React.createContext({
    user:null,
    permissions:null
});

